/**
 * @generated SignedSource<<fed43c447ede037405f2ea174cfa948d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsLiteWallArticle$data = {
  readonly createdDate: number | null | undefined;
  readonly publishedDate: number | null | undefined;
  readonly " $fragmentType": "helpersIsLiteWallArticle";
};
export type helpersIsLiteWallArticle$key = {
  readonly " $data"?: helpersIsLiteWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsLiteWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsLiteWallArticle"
};

(node as any).hash = "639ae1b0071e7ae830591b40a66332ff";

export default node;
